var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-filters-toolbar" },
    [
      _c("CommonFilterTool", {
        attrs: {
          "keep-state-on-query-params": false,
          "filter-meta": _vm.filterMetas,
          "label-formatter": _vm.filterLabelFormatter,
          showClearAll: _vm.isClearAllEnabled(),
        },
        on: { addFilter: _vm.addFilter },
        model: {
          value: _vm.breakdownFilter,
          callback: function ($$v) {
            _vm.breakdownFilter = $$v
          },
          expression: "breakdownFilter",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }